import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { InputsModule } from '../../inputs.module';
import { IRecaptchaInput } from '../../interface';
import { RecaptchaService } from '../../services/recaptcha.service';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
  selector: 'input-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrl: './recaptcha.component.scss',
  imports: [InputsModule, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecaptchaComponent extends BaseInputComponent<IRecaptchaInput> {
  //https://console.cloud.google.com/security/recaptcha/6LcJ52EqAAAAAIhR5IXpKsTmUrgTXtIJrUfK0XLk/overview?project=main-cedar-315223
  cpSiteKey = '6LcJ52EqAAAAAIhR5IXpKsTmUrgTXtIJrUfK0XLk';

  constructor(
    private recaptchaService: RecaptchaService,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  async ngAfterViewInit() {
    this.options.control?.setValue('Just for test');
    return;
    var onResponse = await this.recaptchaService.initGoogleSDK(this.id);
    this._(
      onResponse.subscribe((value) => {
        this.options.control?.setValue(value);
        this.cdr.detectChanges();
      }),
    );
  }
}
